import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import swal from 'sweetalert';

const AddProduct = () => {
    const [productInfo, setProductInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const [model3dPreview, setModel3dPreview] = useState('');

    // Load model-viewer script
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.3.0/model-viewer.min.js';
        document.head.appendChild(script);

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, []);

    const handleOnChange = e => {
        const field = e.target.name;
        const value = e.target.value;
        const newInfo = { ...productInfo };
        newInfo[field] = value;
        setProductInfo(newInfo);

        // Update image preview
        if (field === 'img') {
            setImagePreview(value);
        }
        // Update 3D model preview
        if (field === 'model3d') {
            setModel3dPreview(value);
        }
    } 

    const handleOnSubmit = e => {
        e.preventDefault();
        setLoading(true);
        
        // Convert numeric fields
        const processedData = {
            ...productInfo,
            price: productInfo.price ? parseFloat(productInfo.price) : 0,
            cylinders: productInfo.cylinders ? parseInt(productInfo.cylinders) : undefined,
            gear: productInfo.gear ? parseInt(productInfo.gear) : undefined,
            milage: productInfo.milage ? parseFloat(productInfo.milage) : undefined
        };

        axios.post('https://bikezone-server.onrender.com/products', processedData)
        .then(({ data }) => {
            setLoading(false);
            if(data.insertedId){
                swal({
                    title: "Success!",
                    text: "Product has been added successfully",
                    icon: "success",
                    button: "OK",
                });
                e.target.reset();
                setProductInfo({});
                setImagePreview('');
            }
            else{
                swal({
                    title: "Failed!",
                    text: "Failed to add product",
                    icon: "error",
                    button: "OK",
                });
            }
        })
        .catch(error => {
            setLoading(false);
            console.error('Error adding product:', error);
            swal({
                title: "Error!",
                text: error.response?.data?.message || "Something went wrong",
                icon: "error",
                button: "OK",
            });
        });
    }

    const handleReset = () => {
        setProductInfo({});
        setImagePreview('');
        setModel3dPreview('');
        document.querySelector('form').reset();
    };

    const inputStyle = {
        padding: '12px 16px',
        fontSize: '14px',
        borderRadius: '8px',
        border: '1px solid #dee2e6',
        transition: 'all 0.3s ease',
        width: '100%'
    };

    const labelStyle = {
        fontWeight: '600',
        fontSize: '14px',
        color: '#495057',
        marginBottom: '8px',
        display: 'block'
    };

    return (
        <div style={{ padding: '30px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <Container>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '12px',
                    padding: '30px',
                    marginBottom: '25px',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                    color: 'white'
                }}>
                    <h2 style={{ margin: '0', fontSize: '32px', fontWeight: '700' }}>
                        ➕ Add New Product
                    </h2>
                    <p style={{ margin: '8px 0 0 0', fontSize: '16px', opacity: '0.9' }}>
                        Fill in the details below to add a new bike to your inventory
                    </p>
                </div>

                {/* Form Card */}
                <div style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '40px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                    <Form onSubmit={handleOnSubmit}>
                        <Row>
                            {/* Left Column */}
                            <Col lg={8}>
                                {/* Basic Information Section */}
                                <div style={{ marginBottom: '35px' }}>
                                    <h5 style={{ 
                                        fontSize: '20px', 
                                        fontWeight: '700', 
                                        color: '#2c3e50',
                                        marginBottom: '20px',
                                        paddingBottom: '12px',
                                        borderBottom: '3px solid #667eea',
                                        display: 'inline-block'
                                    }}>
                                        📋 Basic Information
                                    </h5>
                                    
                                    <Row className="g-3 mt-2">
                                        <Col md={12}>
                                            <label style={labelStyle}>
                                                Bike Model <span style={{ color: '#dc3545' }}>*</span>
                                            </label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="title"
                                                placeholder="e.g., Yamaha MT-15, Honda CBR 150R"
                                                style={inputStyle}
                                                required
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>
                                                Price (৳) <span style={{ color: '#dc3545' }}>*</span>
                                            </label>
                                            <input
                                                onChange={handleOnChange}
                                                type="number"
                                                name="price"
                                                placeholder="e.g., 315000"
                                                style={inputStyle}
                                                required
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>
                                                Emission Standard
                                            </label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="emission"
                                                placeholder="e.g., BS6"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={12}>
                                            <label style={labelStyle}>
                                                Image URL <span style={{ color: '#dc3545' }}>*</span>
                                            </label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="img"
                                                placeholder="https://example.com/bike-image.jpg"
                                                style={inputStyle}
                                                required
                                            />
                                        </Col>

                                        <Col md={12}>
                                            <label style={labelStyle}>
                                                3D Model URL
                                            </label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="model3d"
                                                placeholder="https://example.com/3d-model.glb"
                                                style={inputStyle}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {/* Engine Specifications Section */}
                                <div style={{ marginBottom: '35px' }}>
                                    <h5 style={{ 
                                        fontSize: '20px', 
                                        fontWeight: '700', 
                                        color: '#2c3e50',
                                        marginBottom: '20px',
                                        paddingBottom: '12px',
                                        borderBottom: '3px solid #667eea',
                                        display: 'inline-block'
                                    }}>
                                        ⚙️ Engine Specifications
                                    </h5>
                                    
                                    <Row className="g-3 mt-2">
                                        <Col md={12}>
                                            <label style={labelStyle}>Engine Type</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="engine"
                                                placeholder="e.g., Air cooled, 4 Stroke 2 Valve Single cylinder OHC"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Displacement (cc)</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="displacement"
                                                placeholder="e.g., 165cc"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Cylinders</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="number"
                                                name="cylinders"
                                                placeholder="e.g., 1"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Max Power</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="max_power"
                                                placeholder="e.g., 15.2 PS @ 8500 rpm"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Max Torque</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="max_torque"
                                                placeholder="e.g., 14 Nm @ 6500 rpm"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Gear</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="number"
                                                name="gear"
                                                placeholder="e.g., 5"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Fuel Capacity (L)</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="fuel_capacity"
                                                placeholder="e.g., 12L"
                                                style={inputStyle}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {/* Performance & Dimensions Section */}
                                <div style={{ marginBottom: '35px' }}>
                                    <h5 style={{ 
                                        fontSize: '20px', 
                                        fontWeight: '700', 
                                        color: '#2c3e50',
                                        marginBottom: '20px',
                                        paddingBottom: '12px',
                                        borderBottom: '3px solid #667eea',
                                        display: 'inline-block'
                                    }}>
                                        📊 Performance & Dimensions
                                    </h5>
                                    
                                    <Row className="g-3 mt-2">
                                        <Col md={6}>
                                            <label style={labelStyle}>Mileage (km/l)</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="number"
                                                step="0.1"
                                                name="milage"
                                                placeholder="e.g., 40.6"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <label style={labelStyle}>Weight (kg)</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="weight"
                                                placeholder="e.g., 140"
                                                style={inputStyle}
                                            />
                                        </Col>

                                        <Col md={12}>
                                            <label style={labelStyle}>Seat Height (mm)</label>
                                            <input
                                                onChange={handleOnChange}
                                                type="text"
                                                name="seatHeight"
                                                placeholder="e.g., 790"
                                                style={inputStyle}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {/* Description Section */}
                                <div style={{ marginBottom: '35px' }}>
                                    <h5 style={{ 
                                        fontSize: '20px', 
                                        fontWeight: '700', 
                                        color: '#2c3e50',
                                        marginBottom: '20px',
                                        paddingBottom: '12px',
                                        borderBottom: '3px solid #667eea',
                                        display: 'inline-block'
                                    }}>
                                        📝 Description
                                    </h5>
                                    
                                    <label style={{ ...labelStyle, marginTop: '15px' }}>
                                        Product Description
                                    </label>
                                    <textarea 
                                        onChange={handleOnChange} 
                                        name="description"
                                        rows="6"
                                        placeholder="Enter detailed description of the bike including features, performance, and unique selling points..."
                                        style={{
                                            ...inputStyle,
                                            resize: 'vertical',
                                            fontFamily: 'inherit'
                                        }}
                                    />
                                </div>
                            </Col>

                            {/* Right Column - Previews */}
                            <Col lg={4}>
                                {/* Image Preview */}
                                <div style={{
                                    position: 'sticky',
                                    top: '20px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{
                                        background: '#f8f9fa',
                                        borderRadius: '12px',
                                        padding: '25px',
                                        textAlign: 'center',
                                        minHeight: '350px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '2px dashed #dee2e6'
                                    }}>
                                        <h6 style={{ 
                                            fontSize: '16px', 
                                            fontWeight: '600', 
                                            color: '#495057',
                                            marginBottom: '20px'
                                        }}>
                                            🖼️ Image Preview
                                        </h6>
                                        
                                        {imagePreview ? (
                                            <div>
                                                <img 
                                                    src={imagePreview} 
                                                    alt="Product preview" 
                                                    style={{ 
                                                        maxWidth: '100%', 
                                                        maxHeight: '250px',
                                                        borderRadius: '12px',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                        objectFit: 'contain'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.nextSibling.style.display = 'block';
                                                    }}
                                                />
                                                <p style={{ 
                                                    display: 'none',
                                                    color: '#dc3545', 
                                                    fontSize: '14px',
                                                    marginTop: '15px'
                                                }}>
                                                    ❌ Invalid image URL
                                                </p>
                                            </div>
                                        ) : (
                                            <div style={{ color: '#adb5bd' }}>
                                                <div style={{ fontSize: '64px', marginBottom: '15px' }}>
                                                    🏍️
                                                </div>
                                                <p style={{ fontSize: '14px', margin: '0' }}>
                                                    Image preview will appear here
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    {/* 3D Model Preview */}
                                    <div style={{
                                        background: '#f8f9fa',
                                        borderRadius: '12px',
                                        padding: '25px',
                                        textAlign: 'center',
                                        minHeight: '350px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '2px dashed #dee2e6',
                                        marginTop: '20px'
                                    }}>
                                        <h6 style={{ 
                                            fontSize: '16px', 
                                            fontWeight: '600', 
                                            color: '#495057',
                                            marginBottom: '20px'
                                        }}>
                                            🎮 3D Model Preview
                                        </h6>
                                        
                                        {model3dPreview ? (
                                            <div style={{ width: '100%' }}>
                                                <model-viewer
                                                    src={model3dPreview}
                                                    alt="3D model of bike"
                                                    auto-rotate
                                                    camera-controls
                                                    style={{
                                                        width: '100%',
                                                        height: '250px',
                                                        borderRadius: '12px',
                                                        background: 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.querySelector('.error-msg').style.display = 'block';
                                                    }}
                                                />
                                                <p className="error-msg" style={{ 
                                                    display: 'none',
                                                    color: '#dc3545', 
                                                    fontSize: '14px',
                                                    marginTop: '15px'
                                                }}>
                                                    ❌ Invalid 3D model URL
                                                </p>
                                                <p style={{ 
                                                    fontSize: '12px', 
                                                    color: '#6c757d',
                                                    marginTop: '10px',
                                                    fontStyle: 'italic'
                                                }}>
                                                    Drag to rotate • Scroll to zoom
                                                </p>
                                            </div>
                                        ) : (
                                            <div style={{ color: '#adb5bd' }}>
                                                <div style={{ fontSize: '64px', marginBottom: '15px' }}>
                                                    📦
                                                </div>
                                                <p style={{ fontSize: '14px', margin: '0' }}>
                                                    3D model preview will appear here
                                                </p>
                                                <p style={{ fontSize: '12px', marginTop: '8px', color: '#adb5bd' }}>
                                                    Supports .glb and .gltf formats
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Submit Buttons */}
                        <div style={{ 
                            display: 'flex', 
                            gap: '15px', 
                            justifyContent: 'flex-end', 
                            marginTop: '35px',
                            paddingTop: '25px',
                            borderTop: '2px solid #e9ecef'
                        }}>
                            <Button
                                type="button"
                                onClick={handleReset}
                                disabled={loading}
                                style={{
                                    padding: '14px 35px',
                                    borderRadius: '10px',
                                    border: '2px solid #dee2e6',
                                    background: 'white',
                                    color: '#495057',
                                    fontWeight: '600',
                                    fontSize: '15px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.3s ease',
                                    opacity: loading ? 0.5 : 1
                                }}
                                onMouseEnter={(e) => {
                                    if (!loading) {
                                        e.target.style.background = '#f8f9fa';
                                        e.target.style.borderColor = '#adb5bd';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'white';
                                    e.target.style.borderColor = '#dee2e6';
                                }}
                            >
                                🔄 Reset Form
                            </Button>
                            <Button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: '14px 45px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    background: loading 
                                        ? '#adb5bd' 
                                        : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    fontWeight: '700',
                                    fontSize: '15px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: loading ? 'none' : '0 4px 15px rgba(102, 126, 234, 0.4)',
                                    transform: loading ? 'none' : 'translateY(0)'
                                }}
                                onMouseEnter={(e) => {
                                    if (!loading) {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                                }}
                            >
                                {loading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            style={{ marginRight: '10px' }}
                                        />
                                        Adding Product...
                                    </>
                                ) : (
                                    '✓ Add Product'
                                )}
                            </Button>
                        </div>
                    </Form>
                </div>

                {/* Help Text */}
                <div style={{
                    marginTop: '20px',
                    padding: '15px 20px',
                    background: '#e3f2fd',
                    borderRadius: '8px',
                    borderLeft: '4px solid #2196f3'
                }}>
                    <p style={{ 
                        margin: '0', 
                        color: '#1976d2',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <span style={{ fontSize: '18px' }}>💡</span>
                        <strong>Tip:</strong> Fields marked with <span style={{ color: '#dc3545' }}>*</span> are required. Make sure to fill them before submitting.
                    </p>
                </div>
            </Container>
        </div>
    );
};

export default AddProduct;